import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

//import { Select,  } from '@material-ui/core';
import {Grid, Typography, TextField} from '@material-ui/core';
import {Button} from '@material-ui/core';
//import {MenuItem, Button} from '@material-ui/core';


//import Settings from '@material-ui/icons/Settings';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import VpnKeyOutlined from '@material-ui/icons/VpnKeyOutlined';
//import VpnKey from '@material-ui/icons/VpnKey';


import { Navigate } from "react-router-dom";

//import Logo from '../../components/Logo';

import { ApplicationBar } from '../../../components/ApplicationBar';

import { ServerSettings } from './../ServerSettings/ServerSettings'

import { NetworksList } from './NetworksList';

//import { NetworkStatistics } from './NetworksStatistics'
//import { DmrStatistics } from './DmrStatistics'
//import {PerformanceMonitor} from './PerformanceMonitor'
//import { TabbedMenu } from './TabbedMenu'

import { NetworkEditor } from '../NetworkEditor/NetworkEditor';
import { NewNetworkDialog } from './NewNetworkDialog';
import { LicensesEditor } from '../Licenses/Licenses';
import { getObjectByID } from '../../../api/helpers';

import * as dev from '../../../api/dev'
import { VersionUptimeSmall } from '../../../FleetStatistics/pages/ServerMonitor/VersionUptime';

//import { VersionUptimeSmall } from './VersionUptime';

//export 
class ServerManager_ extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            currentNetworkID: '',
            viewAnchor: null,
            toolsAnchor: null,
            tabs: [], //tab panel 
            tab: null,
            networkFilter: '',

            newNetworkDialog: this.props.newNetworkDialog
        }

        this.timer = null

        this.handleAction = this.handleAction.bind(this)
        this.handleNetworkMenu = this.handleNetworkMenu.bind(this)
        this.handleNetworkSelect = this.handleNetworkSelect.bind(this)

        this.handleServerSettingsClick = this.handleServerSettingsClick.bind(this)
        this.handleLicensesClick = this.handleLicensesClick.bind(this)

        this.handleFilterInput = this.handleFilterInput.bind(this)
    }

    handleAction(action){
        this.props.onAction(action)
    }

    handleViewMenu(event){
        this.setState({viewAnchor: event.currentTarget});
    }

    handleViewClose(){
        //this.menuAnchor = null;
        this.setState({viewAnchor: null});
        return null;
    }


    handleNetworkSelect(networkID){
        this.setState({currentNetworkID: networkID})
    }

    componentWillUnmount(){
        clearInterval(this.timer)
    }


    handleNetworkMenu(action, networkID){
        let {t} = this.props 
        switch(action){
            case 'NETWORK_EDITOR_OPEN_EDIT':
                this.props.onAction({type:'NETWORK_EDITOR_SHOW', networkID: networkID})
                break;

            case 'NETWORK_EDITOR_OPEN_ADD':
                this.props.onAction({type:'NETWORK_EDITOR_ADD', networkID: networkID})
                break

            case 'NETWORK_DELETE':{
                //let msg = t('DeleteNetwork?')
                //console.log('NETWORK_DELETE')
                //console.log(networkID)
                let net = getObjectByID(networkID, this.props.networks)
                //console.log(net)

                this.props.onAction({
                    type: 'CONFIRM_DIALOG', 
                    message: t('DeleteNetwork?').replace('?', ': '+net.Name+'?'),
                    onConfirm: ()=>{
                        this.props.onAction({type:'NETWORK_DELETE', networkID: networkID})
                    }
                })

                break
            }

            default: 
                dev.alert('handleNetworkMenu serversettings undefined case  '+action)
        }
    }


    handleServerSettingsClick(){
        this.props.onAction({type:'SERVER_SETTINGS_EDITOR_SHOW'})
    }

    handleLicensesClick(){
        this.props.onAction({type:'LICENSES_EDITOR_SHOW'})
    }

    handleFilterInput(event){
        const val =  event.target.value
        console.log('handleFilterInput')
        console.log(event.target.name +' = ' +val)

        this.setState({[event.target.name]: val})
    }


    render(){

        const {t} = this.props

        if(this.state.navigate){
            return (
<Navigate to={this.state.navigate}></Navigate>
            )
        }

        console.log('NetworkEditor.props');
        console.log(this.props);


        if(this.props.networkEditor && this.props.networkEditor.networkID){
            console.log('this.props.networkEditor')
            console.log(this.props.networkEditor)
            return (
                <NetworkEditor
                    {...this.props.networkEditor}
                    user={this.props.user}

                    onAction={this.props.onAction}
                    statusError={this.props.apiError}
                    statusMessage={this.props.apiMessage}></NetworkEditor>
            );
        }

        if(this.props.serverSettingsEditor && this.props.serverSettingsEditor.open){
            return (
                <ServerSettings 
                        user={this.props.user}
                        networks={this.props.networks}
                        serverSettings={this.props.serverSettingsEditor.serverSettings}
                        onAction={this.props.onAction}
                        statusError={this.props.apiError}
                        statusMessage={this.props.apiMessage}>
                </ServerSettings>

            )
        }

        const licensesEditor = this.props.licensesEditor && this.props.licensesEditor.open ? (
            <LicensesEditor 
                {...this.props.licensesEditor}
                user={this.props.user}
                onAction={this.props.onAction}
                statusError={this.props.apiError}
                statusMessage={this.props.apiMessage}
                />
        ) : '' //licenses={this.props.licenses}
        if(licensesEditor){
            //console.log('this.props.licensesEditor')
            //console.log(this.props.licensesEditor)
            return licensesEditor
        }


        let statusMessage = ''
        if(this.props.statusMessage){
            statusMessage = (
            <Typography align="center" color={this.props.statusError ? "error" : "default"}>
                {this.props.statusMessage}
            </Typography>
            );
        }
        
        
        const newNetworkDialog = this.props.newNetworkDialog && this.props.newNetworkDialog.open?(
            <NewNetworkDialog open={this.props.newNetworkDialog.open}
                {...this.props.newNetworkDialog} 
                onAction={this.props.onAction}/>
        ):'';

        //let uptime = this.props.statisticsOverview
        let version = this.props.onAction({
            type: 'GET_VERSION'
        })
        //alert(version)
        let uptime = {Version: version, UpTime: null}


        return (
            <>

            {newNetworkDialog}
            {licensesEditor}

            <Grid item xs={12} style={{height:'100vh'}}>
                
                <ApplicationBar user={this.props.user}
                    onAction={this.handleAction}>

                    <VersionUptimeSmall data={uptime}></VersionUptimeSmall>
                </ApplicationBar>
                
                <Grid container justify="flex-start" spacing={0} 
                    style={{height:'83%', 
                        paddingTop: 5,
                        borderTop:'1px solid '+theme.palette.border.dialog}} >

                    <Grid xs={12} key="2" item style={{padding:5}}>

                        <Grid  key="1" container direction="row" spacing={1} style={{ padding:5, border2:'1px solid blue'}}>
                            <Grid xs={6} item style={{paddingTop:15}}>
                                    <Button onClick={()=>{this.handleNetworkMenu('NETWORK_EDITOR_OPEN_ADD')}}>
                                        <AddCircleOutlineIcon style={{marginRight:5}} />{t('AddNetwork')}
                                    </Button>
                                    <Button onClick={this.handleServerSettingsClick}>
                                        <SettingsOutlinedIcon style={{marginRight:5}} />{t('ServerSettings')}
                                    </Button>
                                    <Button onClick={this.handleLicensesClick}>
                                        <VpnKeyOutlined style={{marginRight:5}} />{t('Licenses')}
                                    </Button>
                            </Grid>
                            <Grid item xs={6} align="left">
                                <TextField name="networkFilter" 
                                    margin='dense'
                                    variant2="outlined"
                                    size="small"
                                    style={{width: '60%', margin:0}}
                                    label={t('FilterNetworks')}
                                    autoComplete="new-password"
                                    error={false}
                                    value={this.state.networkFilter}
                                    onChange={this.handleFilterInput}
                                />
                            </Grid>
                        </Grid>
                        <Grid  key="2" container direction="row" spacing={1} 
                            style={{height2:this.state.expandMessageArea?'30vh':'60vh', padding:5, border2:'1px solid blue'}}>
    
                            <Grid xs={12} item>

                                {this.state.selectedTab==='settings2' ? 
                                <ServerSettings networks={this.props.networks} onAction={this.props.onAction} data={this.props.serverSettings}></ServerSettings> 
                                : null}


                                <NetworksList networks={this.props.networks} 
                                    filter={this.state.networkFilter}
                                    selectedNetworkID={this.state.currentNetworkID}
                                    onNetworkSelect={this.handleNetworkSelect}
                                    onNetworkMenu={this.handleNetworkMenu} 
                                    onAction={this.props.onAction}
                                    />


                            
                            </Grid>

                        </Grid>

                        
                        
                    </Grid>
                </Grid>
                

                <Grid xs={12} key="5" item style={{border2: '1px solid green', height:'3em'}}>
                    {/*server startus*/} {statusMessage}
                </Grid>

                


            </Grid>
            </>
        );



    }

}

/*
function gb(value){
    return Math.round(value/1000)
}
*/

export const ServerManager = withTranslation()(ServerManager_);